<template>
  <div class="container mt-5">
    <b-row>
      <b-col xl="8" offset-xl="2">
        <bx-box
          variant="gray"
          ref="cameraContainer"
          header-class="col-md-6 col-8 bg-gray"
          actions-class="col-md-6 col-4 text-right"
        >
          <template #header>
            <h3>{{ $t("scan.headline") }}</h3>
          </template>
          <template #actions
            ><b-button variant="primary" :to="{ name: 'index' }">
              {{ $t("actions.back") }}
            </b-button></template
          >
          <qr-scanner
            @scan="onScan"
            @initialized="cameraInitialized"
            @error="onError"
          ></qr-scanner>
        </bx-box>
      </b-col>
    </b-row>
    <b-modal
      ref="errorModal"
      header-bg-variant="cosmos"
      header-class="text-white"
    >
      <template #modal-header>
        <h3>
          <i class="ifr if-cancel text-danger mr-3"></i
          >{{ $t("scan.error.headline") }}
        </h3>
      </template>
      <b-row>
        <b-col cols="12">
          <p>
            {{ error_text }}
          </p>
        </b-col>
      </b-row>
      <template #modal-footer>
        <b-row>
          <b-col cols="12" class="text-center">
            <button class="btn btn-secondary" @click="closeErrorModal">
              {{ $t("actions.ok") }}
            </button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import api from "@a/index";
  import QrScanner from "@c/QrScanner.vue";
  import formularKeyDecoder from "@/services/formulars/formularKeyDecoder";

  export default {
    name: "Scan",
    components: {
      QrScanner,
    },
    data() {
      return {
        error_text: null,
        camera_initialized: false,
        loader: null,
      };
    },
    mounted() {
      this.loader = this.$loading.show({
        container: this.$refs.cameraContainer,
      });
    },
    methods: {
      async onScan(payload) {
        if (payload) {
          try {
            let response = await api.publicToken.getInfo(payload);

            if (response.data.valid) {
              let page = formularKeyDecoder.getFormularPage(
                response.data.formular
              );

              if (page) {
                this.$router.push({
                  name: page,
                  params: { token: response.data.token },
                });
              } else {
                this.error_text = this.$t("scan.error.no_assignment");
                this.$refs.errorModal.show();
              }
            } else {
              this.error_text = this.$t("scan.error.token_invalid");
              this.$refs.errorModal.show();
            }
          } catch (e) {
            this.error_text = this.$t("scan.error.token_invalid");
            this.$refs.errorModal.show();
          }
        }
      },
      cameraInitialized() {
        this.loader.hide();
      },
      onError(text) {
        this.loader.hide();
        this.error_text = text;
        this.$refs.errorModal.show();
      },
      closeErrorModal() {
        this.$refs.errorModal.hide();
        this.error_text = null;
      },
    },
  };
</script>

<style lang="scss">
</style>
